export enum ActionType {
    MOVE = "MOVE",
    BUILD = "BUILD",
    ADD_BUILDER = "ADD_BUILDER",
    RESET = "RESET",
    PASS_GOD_ACTION = "PASS_GOD_ACTION"
}